module.exports = __webpack_public_path__ + "media/images/front/top/slideArwSmall-a391a0875ab1e80e598edac8750bdc9a.png";